import { useQuery } from '@tanstack/react-query';
import { Outlet, useParams } from 'react-router-dom';
import Content from '../../../components/content';
import { api } from '../../../lib/api';
import { CustomMedicationDto } from '../../../lib/ServerApi';

export function MedicationsLayout() {
    const params = useParams<'medicationId'>();

    const { data } = useQuery<CustomMedicationDto>({
        queryKey: ['custom-medication', params.medicationId],
        queryFn: async () => {
            const { data } = await api.customMedication.get(params.medicationId as string);
            return data;
        },
        enabled: Boolean(params.medicationId),
    });

    return (
        <Content headerTitle={data ? data.name : 'Medications'} backNavLink={params.medicationId ? '/settings/medications' : '/settings'}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
